import * as React from 'react';

const SvgInfo = (props: React.SVGAttributes<SVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <g clipPath="url(#info_svg__a)">
      <circle cx={8.511} cy={9} r={8} stroke="currentColor" />
      <path
        d="M7.733 5.65a.777.777 0 1 0 1.555 0 .777.777 0 0 0-1.555 0ZM8.9 7.464h-.777a.13.13 0 0 0-.13.13v4.404c0 .071.059.13.13.13H8.9a.13.13 0 0 0 .13-.13V7.593a.13.13 0 0 0-.13-.13Z"
        fill="currentColor"
      />
      <rect x={7.016} y={7.462} width={1.549} height={1} rx={0.15} fill="currentColor" />
      <rect x={7.016} y={11.127} width={2.994} height={1} rx={0.15} fill="currentColor" />
    </g>
    <defs>
      <clipPath id="info_svg__a">
        <path fill="currentColor" transform="translate(.01 .5)" d="M0 0h17v17H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfo;
